<button type="button"
        class="toggle-password-visibility"
        [attr.aria-label]="isTypePassword ? 'Show password' : 'Hide password'"
        (click)="toggle()"
        (keyup.enter)="$event.stopPropagation()"
>
  <app-icon-feather *ngIf="isTypePassword" icon="eye" [strokeWidth]="2"></app-icon-feather>
  <app-icon-feather *ngIf="!isTypePassword" icon="eye-off" [strokeWidth]="2"></app-icon-feather>
</button>
